export default (res) => {
    return res.data['@odata.count'];
}